import { useIntl } from '@/intl'
import { getPromotedPriceSelector } from '@/scopes/prices/components/selectors'
import { usePricesSelector } from '@/scopes/prices/infrastructure/usePricesSelector'
import { useDecision } from '@optimizely/react-sdk'
import { space, tok, tokPx } from '@sunwebgroup/ui-components'
import { Typography } from '@sunwebgroup/ui-components/uds'
import { styled } from 'styled-components'

const Wrapper = styled.div`
  position: relative;
  background-color: ${tok('semantics_views_tinted_background_color')};
  border-radius: ${tokPx('components_banner_corner_radius')};
  padding: ${space('primitives_space_8')} ${space('primitives_space_12')};
  text-align: center;

  ${Typography}:first-child {
    margin-right: ${space('primitives_space_8')};
  }
`

export function UrgencyBanner() {
  const intl = useIntl()
  const { data } = usePricesSelector(getPromotedPriceSelector)
  const [alternativeUrgencyBanner] = useDecision('ID_383_pdp_test_alternative_urgency_banner_placement')
  const showAlternativeUrgencyBanner = alternativeUrgencyBanner.enabled

  if (showAlternativeUrgencyBanner) {
    return null
  }

  if (!data)
    return null

  const showBanner = data.price.discountPercentage > 0 || data?.campaignId

  if (!showBanner)
    return null

  return (
    <Wrapper className="discount-banner">
      <Typography $variant="body-m-bold-tight">
        {intl.formatMessage({ id: 'prices_emergency_banner_strong_text' })}
      </Typography>
      <Typography>{intl.formatMessage({ id: 'prices_emergency_banner_text' })}</Typography>
    </Wrapper>
  )
}
